<div class="list-group row col-12">
  <ng-content></ng-content>
  @for (row of data; track row) {
    <ng-container *ngTemplateOutlet="rowTemplate || defaultRow; context: { $implicit: row }"></ng-container>
  }
</div>

<ng-template #defaultRow let-row>
  <div class="list-group-content row">
    @for (cell of row | keyvalue; track cell) {
      <div class="table-column col-1">
        {{ cell.value | json }}
      </div>
    }
  </div>
</ng-template>
